module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_mail.dd272383.svg";